import { render, staticRenderFns } from "./panel-economic.vue?vue&type=template&id=87b90482&scoped=true"
import script from "./panel-economic.vue?vue&type=script&lang=js"
export * from "./panel-economic.vue?vue&type=script&lang=js"
import style0 from "./panel-economic.vue?vue&type=style&index=0&id=87b90482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b90482",
  null
  
)

export default component.exports